module.exports = __webpack_public_path__ + "img/9_30.c68669e5.png";